import type { PortableTextTypeComponent } from '@portabletext/react';
import groq from 'groq';

import type { LelandImage } from '../../../types/cmsTypes';
import SanityImage, {
  SANITY_IMAGE_PROJECTION,
  SanityImageHtml,
} from '../../image/SanityImage';

const IMAGE_ROW_TYPE = 'imageRow';
export const IMAGE_ROW_MARK_DEFS_SELECTION = groq`_type == "${IMAGE_ROW_TYPE}" => {
  ...,
  images[] {${SANITY_IMAGE_PROJECTION}}
}`;

interface Props {
  _type: typeof IMAGE_ROW_TYPE;
  images: LelandImage[];
}

const ImageRow: PortableTextTypeComponent<Props> = ({
  value: { images } = {},
}) => {
  if (!images?.length) {
    return null;
  }

  return (
    <div className="my-8 flex w-full flex-col items-center gap-8 md:flex-row">
      {images.map((image, idx) => (
        <div key={idx} className="w-full flex-1 md:w-auto">
          <SanityImage
            key={idx}
            className="w-full rounded-xl"
            image={image}
            sizes={{
              md: `${Math.round(100 / images.length)}vw`,
              dflt: '100vw',
            }}
            alt=""
          />
        </div>
      ))}
    </div>
  );
};

export default ImageRow;

export const ImageRowHtml: PortableTextTypeComponent<Props> = ({
  value: { images } = {},
}) => {
  if (!images?.length) {
    return null;
  }

  return (
    <div>
      {images.map((image, idx) => (
        <div key={idx}>
          <SanityImageHtml
            key={idx}
            image={image}
            sizes={{
              md: `${Math.round(100 / images.length)}vw`,
              dflt: '100vw',
            }}
            alt=""
          />
        </div>
      ))}
    </div>
  );
};
